export const isAppPendSupported = () => {
    // Check App Pend support on legacy web view.
    if (window && window.venice && typeof window.venice.appPend === 'function'){
        return true;
    }

    // App Pend will always be supported on the modern web view.
    if (window && window.paypalMobile) {
        return true;
    }

    return false;
};